import React from "react";
import { Outlet } from "react-router-dom";

import CampaignHost from "../components/campaign/CampaignHost";
import { CampaignFlowProvider } from "../components/campaign/CampaignFlowContext";
import { PushNotificationBootstrap } from "../utils/PushNotificationBootstrap";

export const CampaignWrapper: React.FC = () => {
  return (
    <CampaignFlowProvider>
      <Outlet />
      <CampaignHost />
      <PushNotificationBootstrap />
    </CampaignFlowProvider>
  );
};
